export function sigmetTextKey(rawSigmet) {
  return String(rawSigmet || '').replace(/\s+/g, ' ').trim();
}

function closeRing(coords) {
  if (!Array.isArray(coords) || coords.length < 3) return null;

  const ring = [];
  for (let i = 0; i < coords.length; i++) {
    const lon = Number(coords[i]?.lon);
    const lat = Number(coords[i]?.lat);
    if (!Number.isFinite(lon) || !Number.isFinite(lat)) return null;
    ring.push([lon, lat]);
  }

  const first = ring[0];
  const last = ring[ring.length - 1];
  if (first[0] !== last[0] || first[1] !== last[1]) {
    ring.push([first[0], first[1]]);
  }

  return ring.length >= 4 ? ring : null;
}

export function sigmetsToFeatureCollection(sigmetData) {
  const list = Array.isArray(sigmetData) ? sigmetData : [];
  const features = [];
  const seen = new Set();

  for (let i = 0; i < list.length; i++) {
    const sigmet = list[i];
    const textKey = sigmetTextKey(sigmet?.rawSigmet);
    if (textKey && seen.has(textKey)) continue;
    const ring = closeRing(sigmet?.coords);
    if (!ring) continue;
    if (textKey) seen.add(textKey);

    features.push({
      type: 'Feature',
      properties: {
        rawSigmet: sigmet.rawSigmet || '',
        hazard: sigmet.hazard || '',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [ring],
      },
    });
  }

  return { type: 'FeatureCollection', features };
}

export function sigmetDrawKey(collection) {
  let key = '';
  const features = collection?.features || [];
  for (let i = 0; i < features.length; i++) {
    key += features[i].properties.rawSigmet;
    key += '\0';
  }
  return key;
}
